import {PAdbContext} from "../PA.Core/PAdbContext";
import {AuditService} from "../PA.Core/Security/AuditService";
import {TPMEventBO} from "./TPMEventBO";
import {auditFieldFK, AuditUtils, IAuditField} from "../PA.Core/Basic/AuditUtils";
import {AuditLogType} from "../PA.Core/PA.Core.IF.Audit";
import {WB_ProductGroupRow} from "../PA.Core/PAdbSchemaRows";
import * as _ from "lodash";

export class TPMEventBOAudit {


    static async TPMEventAuditBO(TPMEventBO: TPMEventBO): Promise<AuditService> {
        const self = TPMEventBO
        const auditService = new AuditService(self.dbContext)
        auditService.setReference("TPMEvent", self.drWB_TPMEvent.cif.WB_TEVT_ID)

        // @ts-ignore
        self.deleteKeys = self.deleteKeys || {}
        // @ts-ignore
        let deleteKeys: any = self.deleteKeys

        const tpmEventParams: IAuditField [] = [
            {fieldName: "EVENT_NAME",              realName: "Event Name", bAllMsg: true }, //create
            {fieldName: "EVENT_ID",                realName: "Event ID",  bAllMsg: true }, //create
            {fieldName: "WB_CUST_ID_SUBPLANNING",  realName: "Sub Planning Customer",  ...auditFieldFK.customer},
            {fieldName: "INSTORE_START_DT",        realName: "Instore Start Date"},
            {fieldName: "INSTORE_END_DT",          realName: "Instore End Date"},
            {fieldName: "COVERAGE_FACTOR",         realName: "Coverage Factor"},
            {fieldName: "SHIPMENT_START_DT",       realName: "Shipment Start Date"},
            {fieldName: "SHIPMENT_END_DT",         realName: "Shipment End Date"},
        ]

        // TPM Product Group Rows
        const tpmEventProductGroupParams: IAuditField [] = [
            {fieldName: "WB_PRDGRP_ID",          realName: "Product Group", ...auditFieldFK.productGroup, bAllMsg: true},
            {fieldName: "CNS_LIFT_PCNT_OVRD",    realName: "Lift %",          decimalCount: 2 },
            {fieldName: "CNS_FORWARD_BUY_PCNT",  realName: "Forward Buy %",   decimalCount: 2 },
            {fieldName: "COVERAGE_FACTOR",       realName: "Coverage Factor", decimalCount: 2 },
            {fieldName: "BASE_PRICE",            realName: "Base Price",      decimalCount: 2 },
            {fieldName: "EDLP_PRICE",            realName: "EDLP Price",      decimalCount: 2 },
            {fieldName: "PROMOTED_PRICE",        realName: "Promoted Price",  decimalCount: 2 }
        ]

        // TPM Product Rows
        const tpmEventProductParams: IAuditField [] = [
            {fieldName: "WB_PROD_ID",        realName: "Product", ...auditFieldFK.product, bAllMsg: true}
        ]

        //TPM Event Spend Rows
        const tpmEventSpendParams: IAuditField [] = [
            {fieldName: "EVENT_SPEND_ID",        realName: "Event Spend ID",   bAllMsg: true},
            {fieldName: "EVENT_SPEND_NAME",      realName: "Event Spend Name", bAllMsg: true},
            {fieldName: "RATE_AMT",              realName: "Rate",             decimalCount: 2 },
            {fieldName: "RATE_BASIS_ID",         realName: "Rate Basis",       domainId: "RateBasis"},
            {fieldName: "RATE_UOM",              realName: "Rate UOM",         domainId: "RateUOM"},
            {fieldName: "REDEMPTION_RATE_PCNT",  realName: "Redemption Rate"},
            {fieldName: "PAYMENT_METHOD",        realName: "Payment Method",   domainId: "PaymentMethod"},
            {fieldName: "PAID_IN_FULL_IND",      realName: "Paid In Full", booleanIndField: true},
            {fieldName: "SHIPMENT_START_DT",     realName: "Shipment Start Date"},
            {fieldName: "SHIPMENT_END_DT",       realName: "Shipment End Date"},
            {fieldName: "INSTORE_START_DT",      realName: "Instore Start Date"},
            {fieldName: "INSTORE_END_DT",        realName: "Instore End Date"}
        ]

        //TPM Event Spend product Rows
        const tpmEventSpendProductGroupParams: IAuditField [] = [
            {fieldName: "WB_PRDGRP_ID",   realName: "Product Group", ...auditFieldFK.productGroup, bAllMsg: true},
            {fieldName: "INCLUDE_IND",    realName: "Include Indicator", booleanIndField: true},
            {fieldName: "RATE_AMT",       realName: "Rate", decimalCount: 4},
        ]
        //TPM Event Spend Product Rows
        const tpmEventSpendProductParams: IAuditField [] = [
            {fieldName: "WB_PROD_ID",    realName: "Product", ...auditFieldFK.product, bAllMsg: true},
            {fieldName: "INCLUDE_IND",   realName: "Include Indicator", booleanIndField: true},
            {fieldName: "RATE_AMT",      realName: "Rate", decimalCount: 4},
        ]

        // TPM Event Tag Rows
        const tpmEventTagParams: IAuditField [] = [
            {fieldName: "WB_TAG_ID",        realName: "Tags", ...auditFieldFK.tag, bAllMsg: true}
        ]

        // Execute Audit Logging
        await AuditUtils.logRecord(auditService, self.WB_TPMEvent, tpmEventParams, {objectName: 'Event', deletedKeys: deleteKeys})

        // TPM Product Group Rows
        for(let aTPMPrdGrpRow of self.drWB_TPMEvent.WB_TPM_EventProductGroupRows) {
            await AuditUtils.logRecord(auditService, aTPMPrdGrpRow, tpmEventProductGroupParams,{objectName: 'Event Product Group', deletedKeys: deleteKeys})
        }

        // TPM Product Rows
        for(let aTPMPrdRow of self.drWB_TPMEvent.WB_TPM_EventProductRows) {
            let bLogInsertDeletes = aTPMPrdRow.cif.ROW_TYPE === 'Display'
            await AuditUtils.logRecord(auditService, aTPMPrdRow, tpmEventProductParams,{objectName: 'Event Product', deletedKeys: deleteKeys, bLogDeletes: bLogInsertDeletes, bLogCreates: bLogInsertDeletes})
        }


        //TPM Event Spend Rows
        for(let aTPMEvtSpendRow of self.drWB_TPMEvent.WB_TPM_EventSpendRows) {

            await AuditUtils.logRecord(auditService, aTPMEvtSpendRow, tpmEventSpendParams,{objectName: 'Tactic ', deletedKeys: deleteKeys});

            //TPM Event Spend PG Rows
            for(let sEvtPrdGrp of aTPMEvtSpendRow.WB_TPM_EventSpendPrdGrpRows || []) {
               await AuditUtils.logRecord(auditService, sEvtPrdGrp, tpmEventSpendProductGroupParams,{objectName: `Tactic (${aTPMEvtSpendRow.cif.EVENT_SPEND_ID}) Product Group `, deletedKeys: deleteKeys});
            }

            //TPM Event Spend Prd Rows
            for(let sEvtSpendPrd of aTPMEvtSpendRow.WB_TPM_EventSpendPrdRows || []) {
               await AuditUtils.logRecord(auditService, sEvtSpendPrd, tpmEventSpendProductParams,
                 {objectName: `Tactic (${aTPMEvtSpendRow.cif.EVENT_SPEND_ID})  Product `, deletedKeys: deleteKeys, bLogDeletes: false, bLogCreates: false});
            }
        }

        // TPM Event Tag Rows
        for(let aTPMTagRow of self.drWB_TPMEvent.WB_TPM_EventTagRows) {
            await AuditUtils.logRecord(auditService, aTPMTagRow, tpmEventTagParams,{objectName: 'Tag ', deletedKeys: deleteKeys});
        }

        return auditService
    }

    /**
     * Audit Log for copy
     * @param TPMEventBO
     * @param oldEvent
     * @return Promise<AuditService>
     */
    static async CopyTPMEventAuditBO(TPMEventBO: TPMEventBO, oldEvent: TPMEventBO, delPrdGrps?: WB_ProductGroupRow[]): Promise<AuditService> {
        const self = TPMEventBO;
        const auditService = new AuditService(new PAdbContext({}))
        auditService.setReference("TPMEvent", self.drWB_TPMEvent.cif.WB_TEVT_ID)

        auditService.LogSync(AuditLogType.Copy, `Event Copied from ${oldEvent.WB_TPMEvent.cif.EVENT_NAME} (${oldEvent.WB_TPMEvent.cif.EVENT_ID})`)

        _.forEach(delPrdGrps, (aDelPrdGrp: WB_ProductGroupRow) => {
            auditService.LogSync(AuditLogType.Info, `PPG ID ${aDelPrdGrp.cif.PRODUCT_GROUP_ID} - ${aDelPrdGrp.cif.PRODUCT_GROUP_NAME} was removed from the copied event; it is not valid in this planning year.`)

        })
        return auditService;

    }
}
